import request from '@/utils/request'

export function pageRedeemOrder(query) {
  return request({
    url: '/biz/giftcard/redeem/page',
    method: 'get',
    params: query
  })
}

export function getRedeemOrderDetail(orderId) {
  return request({
    url: '/biz/giftcard/redeem/detail',
    method: 'get',
    params: { orderId }
  })
}

export function auditRedeemOrder(data) {
  return request({
    url: '/biz/giftcard/redeem/audit',
    method: 'post',
    data: data
  })
}

export function claimRedeemOrder(orderId) {
  return request({
    url: '/biz/giftcard/redeem/claim',
    method: 'post',
    params: { orderId }
  })
}

export function listRejectPhrases(bizType, all) {
  return request({
    url: '/biz/giftcard/reject-phrase/list',
    method: 'get',
    params: { bizType: bizType || 1, all: !!all }
  })
}

export function saveRejectPhrase(data) {
  return request({
    url: '/biz/giftcard/reject-phrase/save',
    method: 'post',
    data: data
  })
}

export function deleteRejectPhrase(id) {
  return request({
    url: '/biz/giftcard/reject-phrase/delete',
    method: 'post',
    params: { id }
  })
}

export function pageWithdraw(query) {
  return request({
    url: '/biz/giftcard/withdraw/page',
    method: 'get',
    params: query
  })
}

export function getWithdrawDetail(withdrawId) {
  return request({
    url: '/biz/giftcard/withdraw/detail',
    method: 'get',
    params: { withdrawId }
  })
}

export function auditWithdraw(data) {
  return request({
    url: '/biz/giftcard/withdraw/audit',
    method: 'post',
    data: data
  })
}

export function claimWithdraw(withdrawId) {
  return request({
    url: '/biz/giftcard/withdraw/claim',
    method: 'post',
    params: { withdrawId }
  })
}
